import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20warm%20artistic%20illustration%20inspired%20by%20Japanese%20maid%20culture%2C%20soft%20delicate%20lace%20patterns%20floating%20in%20warm%20golden%20light%2C%20abstract%20floral%20elements%2C%20cream%20and%20soft%20rose%20color%20palette%2C%20dreamy%20atmospheric%20composition%2C%20fine%20art%20style%2C%20gentle%20gradients%2C%20cultural%20elegance%20with%20negative%20space&width=1920&height=1080&seq=hero-maid-culture&orientation=landscape"
        alt="女仆不只是工作 - 重新定义女仆文化的深度体验"
        className="absolute inset-0 w-full h-full object-cover"
        title="女仆不只是工作 - 重新定义女仆文化的深度体验"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
          女仆不只是工作
        </h1>
        <p className="text-sm md:text-xl text-white/85 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
          探索女仆文化背后的情感连接、角色认同与生活方式。
          用深度内容重新定义女仆文化的多元价值，为每一位热爱女仆文化的人点亮一束温暖的光。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/maid-cafe-culture"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/20"
          >
            开始探索
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full text-sm font-medium hover:bg-white/25 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}